export const AdvJavaFees = { totalFees: 19950, discountedFees: 3450, GST: true };
export const AdvJavaSelfFees = { totalFees: 4999, discountedFees: 450, GST: true };
export const AdvJavaLiveFees = { totalFees: 19950, discountedFees: 3450, GST: true };

export const JavaFees = { totalFees: 11845, discountedFees: 999, GST: true, comboCount: 0 };
export const JavaSelfFees = { totalFees: 4999, discountedFees: 550, GST: true };
export const JavaLiveFees = { totalFees: 11845, discountedFees: 999, GST: true };

export const AIMLFees = { totalFees: 27500, discountedFees: 2750, GST: true, comboCount: 0 };
export const AIMLSelfFees = { totalFees: 4999, discountedFees: 550, GST: true, comboCount: 0 };
export const AIMLLiveFees = { totalFees: 27500, discountedFees: 2750, GST: true, comboCount: 0 };

export const KubernetesFees = { totalFees: 19500, discountedFees: 1950, GST: true, comboCount: 0 };
export const KubernetesSelfFees = { totalFees: 4999, discountedFees: 550, GST: true, comboCount: 0 };
export const KubernetesLiveFees = { totalFees: 15500, discountedFees: 1550, GST: true, comboCount: 0 };

export const DMFees = { totalFees: 5250, discountedFees: 999, GST: true, comboCount: 0 };
export const DMSelfFees = { totalFees: 3999, discountedFees: 650, GST: true, comboCount: 0 };
export const DMLiveFees = { totalFees: 13750, discountedFees: 2750, GST: true, comboCount: 0 };
export const MLFees = { totalFees: 11845, discountedFees: 945, GST: true, comboCount: 0 };
export const AIFees = { totalFees: 11845, discountedFees: 945, GST: true, comboCount: 0 };
export const PlacementFees = { totalFees: 14750, discountedFees: 2950, GST: true };

export const TableauSelfFees = { totalFees: 4999, discountedFees: 550, GST: true, comboCount: 0 };
export const TableauLiveFees = { totalFees: 11845, discountedFees: 950, GST: true, comboCount: 0 };

// export const FrontendFees = { totalFees: 11845, discountedFees: 950, GST: true, comboCount: 0 };
export const FrontnedSelfFees = { totalFees: 3999, discountedFees: 650, GST: true, comboCount: 0 };
export const FrontnedLiveFees = { totalFees: 11845, discountedFees: 950, GST: true, comboCount: 0 };

// export const FrontendFees = { totalFees: 17500, discountedFees: 1750, GST: true, comboCount: 1 };
export const FrontendFees = { totalFees: 19500, discountedFees: 1950, GST: true, comboCount: 1 };
export const FrontendFeesv2 = { totalFees: 19500, discountedFees: 1950, GST: true, comboCount: 1 };

export const PythonFees = { totalFees: 17500, discountedFees: 1750, GST: true, comboCount: 1 };

// export const PythonAIMLFees = { totalFees: 14500, discountedFees: 1450, GST: true, comboCount: 2 };
export const PythonAIMLFees = { totalFees: 19500, discountedFees: 1950, GST: true, comboCount: 2 };
export const PythonAIMLFeesv2 = { totalFees: 19500, discountedFees: 1950, GST: true, comboCount: 2 };


// export const DAFees = { totalFees: 14500, discountedFees: 1450, GST: true, comboCount: 1 };
export const DAFees = { totalFees: 29500, discountedFees: 2950, GST: true, comboCount: 2 };
export const DAFeesv2 = { totalFees: 29500, discountedFees: 2950, GST: true, comboCount: 2 };

export const DSFees = { totalFees: 11845, discountedFees: 945, GST: true, comboCount: 1 };

export const AWSFees = { totalFees: 14500, discountedFees: 1450, GST: true, comboCount: 2 };

// export const AWS_SAA_C03_Fees = { totalFees: 19500, discountedFees: 1950, GST: true, comboCount: 2 };
export const AWS_SAA_C03_Fees = { totalFees: 27500, discountedFees: 2750, GST: true, comboCount: 2 };
export const AWS_SAA_C03_Feesv2 = { totalFees: 27500, discountedFees: 2750, GST: true, comboCount: 2 };
export const MultiCloudDevOpsCTFees = { totalFees: 127500, discountedFees: 9750, GST: true, comboCount: 2 };

// export const GCPFees = { totalFees: 14500, discountedFees: 1450, GST: true, comboCount: 1 }
export const GCPFees = { totalFees: 27500, discountedFees: 2750, GST: true, comboCount: 2 }
export const GCPFeesv2 = { totalFees: 27500, discountedFees: 2750, GST: true, comboCount: 2 }

// export const CEHFees = { totalFees: 27500, discountedFees: 2750, GST: true, comboCount: 1 }
export const CEHFees = { totalFees: 34500, discountedFees: 3450, GST: true, comboCount: 2 }
export const CEHFeesv2 = { totalFees: 34500, discountedFees: 3450, GST: true, comboCount: 2 }
export const CybersecurityCTFees = { totalFees: 124500, discountedFees: 9450, GST: true, comboCount: 2 }

export const AZUREFees = { totalFees: 14500, discountedFees: 1450, GST: true, comboCount: 1 };

// export const PMPFees = { totalFees: 27500, discountedFees: 2750, GST: true, comboCount: 1 };
export const PMPFees = { totalFees: 34500, discountedFees: 3450, GST: true, comboCount: 2 };
export const PMPFeesv2 = { totalFees: 34500, discountedFees: 3450, GST: true, comboCount: 2 };
export const ManagementCTFees = { totalFees: 134500, discountedFees: 9950, GST: true, comboCount: 2 };

// export const ITILFees = { totalFees: 27500, discountedFees: 2750, GST: true, comboCount: 1 };
export const ITILFees = { totalFees: 34500, discountedFees: 3450, GST: true, comboCount: 2 };
export const ITILFeesv2 = { totalFees: 34500, discountedFees: 3450, GST: true, comboCount: 2 };

// export const BAFees = { totalFees: 27500, discountedFees: 2750, GST: true, comboCount: 1 };
export const BAFees = { totalFees: 34500, discountedFees: 3450, GST: true, comboCount: 1 };
export const BAFeesv2 = { totalFees: 34500, discountedFees: 3450, GST: true, comboCount: 1 };

// export const FAFees = { totalFees: 27500, discountedFees: 2750, GST: true, comboCount: 1 };
export const FAFees = { totalFees: 34500, discountedFees: 3450, GST: true, comboCount: 1 };
export const FAFeesv2 = { totalFees: 34500, discountedFees: 3450, GST: true, comboCount: 1 };

// export const PowerBIFees = { totalFees: 14500, discountedFees: 1450, GST: true, comboCount: 2 };
export const PowerBIFees = { totalFees: 19500, discountedFees: 1950, GST: true, comboCount: 2 };
export const PowerBIFeesv2 = { totalFees: 19500, discountedFees: 1950, GST: true, comboCount: 2 };

// export const DevOpsFees = { totalFees: 34500, discountedFees: 3450, GST: true, comboCount: 2 };
export const DevOpsFees = { totalFees: 34500, discountedFees: 3450, GST: true, comboCount: 2 };
export const DevOpsFeesv2 = { totalFees: 34500, discountedFees: 3450, GST: true, comboCount: 2 };

// export const AzureDevOpsFees = { totalFees: 32500, discountedFees: 3250, GST: true, comboCount: 1 };
export const AzureDevOpsFees = { totalFees: 34500, discountedFees: 3450, GST: true, comboCount: 2 };
export const AzureDevOpsFeesv2 = { totalFees: 34500, discountedFees: 3450, GST: true, comboCount: 2 };

// export const DockerFees = { totalFees: 11845, discountedFees: 950, GST: true, comboCount: 2 };
export const DockerFees = { totalFees: 19845, discountedFees: 1950, GST: true, comboCount: 2 };
export const DockerFeesv2 = { totalFees: 19845, discountedFees: 1950, GST: true, comboCount: 2 };

// export const TableauFees = { totalFees: 11845, discountedFees: 950, GST: true, comboCount: 1 };
export const TableauFees = { totalFees: 19845, discountedFees: 1950, GST: true, comboCount: 1 };
export const TableauFeesv2 = { totalFees: 19845, discountedFees: 1950, GST: true, comboCount: 1 };

export const AWSAssociateFees = { totalFees: 11845, discountedFees: 950, GST: true, comboCount: 2 };

export const AWSProfessionalFees = { totalFees: 11845, discountedFees: 950, GST: true, comboCount: 2 };

export const AWSCloudFees = { totalFees: 19500, discountedFees: 1950, GST: true, comboCount: 2 }

// export const MultiCloudFees = { totalFees: 33000, discountedFees: 3300, GST: true, comboCount: 3 };
export const MultiCloudFees = { totalFees: 44500, discountedFees: 4450, GST: true, comboCount: 3 };
export const MultiCloudFeesv2 = { totalFees: 44500, discountedFees: 4450, GST: true, comboCount: 3 };

// export const ExcelFees = { totalFees: 11845, discountedFees: 950, GST: true, comboCount: 2 };
export const ExcelFees = { totalFees: 19000, discountedFees: 1950, GST: true, comboCount: 2 };
export const ExcelFeesv2 = { totalFees: 19000, discountedFees: 1950, GST: true, comboCount: 2 };

export const DAUsingPythonFees = { totalFees: 17500, discountedFees: 1750, GST: true, comboCount: 2 };

export const MLUsingPythonFees = { totalFees: 27500, discountedFees: 2750, GST: true, comboCount: 2 };

export const DataScientistFees = { totalFees: 39500, discountedFees: 3950, GST: true, comboCount: 2 };

export const GenerativeAIFees = { totalFees: 37500, discountedFees: 3750, GST: true, comboCount: 2 };

export const FullStackAIFees = { totalFees: 59500, discountedFees: 5950, GST: true, comboCount: 2 };
export const DSGenAICTFees = { totalFees: 159500, discountedFees: 9950, GST: true, comboCount: 2 };

// export const NodeJSFees = { totalFees: 22500, discountedFees: 2250, GST: true, comboCount: 2 };
export const NodeJSFees = { totalFees: 29500, discountedFees: 2950, GST: true, comboCount: 2 };
export const NodeJSFeesv2 = { totalFees: 29500, discountedFees: 2950, GST: true, comboCount: 2 };

// export const MERNFullStackFees = { totalFees: 34500, discountedFees: 3450, GST: true, comboCount: 2 };
export const MERNFullStackFees = { totalFees: 44500, discountedFees: 4450, GST: true, comboCount: 2 };
export const MERNFullStackFeesv2 = { totalFees: 44500, discountedFees: 4450, GST: true, comboCount: 2 };

export const AZ104Fees = { totalFees: 19500, discountedFees: 1950, GST: true, comboCount: 2 };

export const AZ305Fees = { totalFees: 27500, discountedFees: 2750, GST: true, comboCount: 2 };